/**
 * Shared list-row callbacks. Every list screen reaches for these so the
 * checkbox-toggle and open-task behaviour stay consistent across the app.
 */

import { useNavigate } from '@tanstack/react-router';
import type { TaskRowModel } from '@k-os/ui';
import { useToggleTaskDone } from '../api/tasks';

export function useOpenTask(): (task: TaskRowModel) => void {
  const navigate = useNavigate();
  return (task) => navigate({ to: '/tasks/item/$id', params: { id: task.id } });
}

/**
 * Returns a callback shaped for `<TaskRow onComplete={...} />` that toggles
 * the task between done and not-done. Open → done via /complete; done →
 * next via PATCH. Optimistic cache updates make the row move between
 * groups instantly so the list animation kicks in immediately.
 */
export function useToggleTask(): (task: TaskRowModel) => void {
  const toggle = useToggleTaskDone();
  return (task) => toggle.mutate({ id: task.id, status: task.status });
}
